import Vue from 'vue'
import pgDialogMethod from './dialog-form-method.vue'

const DialogConstructor = Vue.extend(pgDialogMethod)

let instanceDialog
const instancesDialog = []
let seedDialog = 1

/**
 * 通过js调用弹窗表单
 * @param {object} options
 * @param {string} options.cacelText
 * @param {string} options.secoundConfirmText
 * @param {string} options.confirmText 确 认
 * @param {boolean} options.showClose
 * @param {string} options.title
 * @param {string} options.width
 * @param {array|object} options.formItems
 * @param {string} options.formItemsCode
 * @param {object} options.extendCompileData
 * @param {object} options.formModel
 * @param {object} options.formUrl
 * @param {object} options.formParam
 * @returns {Promise} {dialogData, onClose, type: ''/'secoundConfirm'/'confirm'}
 */
export function pgDialogFormService(options) {
  return new Promise((resolve) => {
    instanceDialog = new DialogConstructor()
    instanceDialog.id = `dialog-form-method${seedDialog++}`
    options.close = function () {
      pgDialogFormService.close(instanceDialog.id)
    }

    const resFun = () => {
      return new Promise((resolveChild) => {
        instanceDialog.setAllLoading()
        instanceDialog.setProps('beforeClose', async ({ dialogData, onClose: close, type }) => {
          resolveChild({ dialogData, onClose: close, type, resFun })
        })
      })
    }
    options.beforeClose = async ({ dialogData, onClose: close, type }) => {
      resolve({ dialogData, onClose: close, type, resFun })
    }
    instanceDialog.$mount()
    document.body.appendChild(instanceDialog.$el)
    instanceDialog.show(options)
    instancesDialog.push(instanceDialog)
  })
}

pgDialogFormService.close = function (id) {
  const index = instancesDialog.findIndex((ins) => ins.id === id)
  if (index > -1) {
    instancesDialog.splice(index, 1)
  }
}
